module.exports = __webpack_public_path__ + "img/icon_live_2023@2x.63e92855.png";